import React from 'react'
import { useTranslation } from 'react-i18next'
import { ConsentPrompt } from '@blokhub/consent-system'
import ClientOnly from './ClientOnly'

const COUNTRY = process.env.GATSBY_COUNTRY
const DEBUG = process.env.NODE_ENV !== 'production'
const baseUrl = DEBUG
  ? 'http://localhost:8000'
  : 'https://app.blok.ai'

const PageWrapper = ({ children }) => {
  const { i18n } = useTranslation()

  return (
    <>
      {children}
      <ClientOnly>
        <ConsentPrompt country={COUNTRY} language={i18n.language} baseUrl={baseUrl} />
      </ClientOnly>
    </>
  )
}

export default PageWrapper
